module.exports = __webpack_public_path__ + "static/media/nUSD-LP.84d871a6.png";